import { INTEGRATION_FORM_CONTENT } from 'modules/mobileApps/constants';
import { useIntegrationMetadataContext } from 'modules/mobileApps/context/integrationMetadata';
import { IntegrationPlatform } from 'modules/mobileApps/types';
import { FormField } from 'ui/formField';
import { StyledRadioList, StyledWarningBadge } from '../ApnsIntegrationForm.styled';

export const EnvironmentRadioList = () => {
  const content = INTEGRATION_FORM_CONTENT.environments;
  const envOptions = [content.prod, content.sandbox];

  const { selectedIntegration, setSelectedIntegration } = useIntegrationMetadataContext();

  const handleSelect = (platform: IntegrationPlatform) => {
    if (selectedIntegration) setSelectedIntegration({ ...selectedIntegration, platform });
  };

  return (
    <FormField>
      <StyledRadioList
        data-test="env-radio-list"
        name="env"
        label={content.label}
        options={envOptions}
        onSelect={handleSelect}
        value={selectedIntegration?.platform ?? IntegrationPlatform.APNS}
      />
      <StyledWarningBadge>
        <div data-test={'warning-block'}>
          Additional setup required
          <p>
            Certificate based authentication requires separate certificates for each environment.
            You will need to upload an additional certificate to send to multiple environments.
          </p>
        </div>
      </StyledWarningBadge>
    </FormField>
  );
};
